import * as React from 'react';
import axios, { CancelTokenSource } from 'axios';
import { useHistory } from "react-router-dom";
import { getUrlParameter } from '../../utilities/UrlHelper';
import { CheckOutState, CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import Loader from '../common/Loader';
import { PaymentDetail } from '../../models/payment/PaymentDetail';
import { CheckState, CheckStateContext } from '../../providers/CheckStateContextProvider';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { MakePaymentRequest } from '../../models/payment/MakePaymentRequest';
import { PaymentDigitalWalletType } from '../../models/payment/PaymentDigitalWalletType';
import { MakePaymentResponse } from '../../models/payment/MakePaymentResponse';
import { ErrorCode } from '../../models/common/ErrorCode';
import { String_PayCheck_ErrorPaymentFailed, String_PayCheck_PaymentExceedsAmountDue, String_System_ConnectionError, String_System_GeneralError } from '../../utilities/StringHelper';
import { SplitType } from '../../models/common/SplitType';
import ErrorDialog, { ErrorDialogProps } from '../common/ErrorDialog';
import { GlobalPayHppResponse } from '../../models/payment/GlobalPayHppResponse';

export default function GlobalPayPaymentCallback() {
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [errorDialogOpen, setErrorDialogOpen] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>('');
    const [errorDialogTryAgain, setErrorDialogTryAgain] = React.useState<boolean>(true);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    let history = useHistory();

    React.useEffect(() => {
        var hppResponse: GlobalPayHppResponse = JSON.parse(getUrlParameter(history.location.search, 'hppResponse'));  

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        validateGlobalPayPayment(source, hppResponse)
    }, []);

    const validateGlobalPayPayment = async (cancelTokenSource: CancelTokenSource, hppResponse: GlobalPayHppResponse) => {
        const paymentDetail: PaymentDetail = {
            tip: checkState.state.tip,
            tax: checkState.state.checkTotal!!.tax,
            sub_total: checkState.state.checkTotal!!.sub_total,
            amount_to_pay: checkState.state.checkTotal!!.amount_due,
            total: checkState.state.checkTotal!!.total,
            zip_code: '',
            token: '',
            serial_number: '',
            extended_card_data: '',
            card_number_last_four: '',
            guest_last_name: '',
            room_number: '',
            session_id: ''
        }

        const request: MakePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            payment_method: null,
            payment_digital_wallet_type: PaymentDigitalWalletType.None,
            payment_detail: paymentDetail,
            globalpay_hpp_response: hppResponse,
            apple_pay_token: null,
            google_pay_token: null
        };

        sendPaymentToServer(cancelTokenSource, request);
    }

    const sendPaymentToServer = async (cancelTokenSource: CancelTokenSource, request: MakePaymentRequest) => {
        let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + checkState.state.checkSummary!!.id + "/payment/process"
    
        const headers = {
            'X-API-Key': checkOutState.state.restaurantApiKey,
            'location_id': checkOutState.state.restaurantId
        }
            
        axios.post(url, request, { headers, cancelToken: cancelTokenSource.token })
        .then(function(response) {
            let r = response.data as MakePaymentResponse;
            handlePaymentComplete(r);                
        })
        .catch(function(error) {
            if (error.response) {
                setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setLoaded(true);
            }
            else {
                setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setLoaded(true);
            }
        });
    }

    const handlePaymentComplete = (r: MakePaymentResponse) => {
        if (r.success === true) {
            const state: CheckState = checkState.state;
            state.checkSummary = null;
            state.checkDetail = null;
            state.checkTotal = null;
            state.paymentId = null;
            state.splitType = SplitType.None;
            state.splitPercentage = 0;
            state.splitAmount = 0;
            state.splitEvenlyCount = 0;
            state.checkTotalWithTip = '';
            state.tip = 0;
            state.tipString = '';
            checkState.setState(state);

            if (r.restaurant_id != null) {
                const coState: CheckOutState = checkOutState.state;
                coState.restaurantId = r.restaurant_id;
                checkOutState.setState(coState);
            }

            history.push({
                pathname: '/postcheckout/review',
                state: { 
                    paymentId: r.check_please_payment_id,
                }
            });
        }
        else {
            if (r.error_code === ErrorCode.PaymentFailed)
            {
                setErrorMessage(String_PayCheck_ErrorPaymentFailed.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setLoaded(true);
            }
            else {
                setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setLoaded(true);
            }
        }
    }

    const handleErrorDialogClose = (event: React.MouseEvent<HTMLElement>) => {
        setErrorDialogOpen(false);
        history.go(-2);
    }

    const errorDialogProps: ErrorDialogProps = {
        open: errorDialogOpen,
        message: errorMessage,
        tryAgain: errorDialogTryAgain,
        onCloseHandler: handleErrorDialogClose,
    }

    return (
        <div>
            {!loaded &&
                <Loader />  
            }

            <ErrorDialog 
                open={errorDialogProps.open}
                message={errorDialogProps.message}
                tryAgain={errorDialogProps.tryAgain}
                onCloseHandler={errorDialogProps.onCloseHandler} />   
           
        </div>
    );
}

